import { get as getCookie } from 'es-cookie';

//reliant on window.DepositAccount.sessionCheckedPromise

async function getDmaCode() {
    //may not have dma code until after session started initially
    const dmaCodePromise: Promise<{ geodma: number | undefined }> = new Promise(async function (resolve) {
        // Outside of the DepositAccount
        if((<any>window).DepositAccount === undefined){
            return resolve({ geodma: undefined });
        }
        //if window.DepositAccount.sessionCheckedPromise doesn't exist, then promise completes immediately
        await Promise.race([(<any>window).DepositAccount.sessionCheckedPromise, timeout(500)]);
        const dmaString = getCookie('geodma');
        resolve({ geodma: parseInt(dmaString) });
    });
    return dmaCodePromise;
}

async function getStateCode() {
    //may not have state code until after session started initially
    const stateCodePromise: Promise<{ geostate: string | undefined }> = new Promise(async function (resolve) {
        // Outside of the DepositAccount
        if((<any>window).DepositAccount === undefined){
            return resolve({ geostate: undefined });
        }
        //if window.DepositAccount.sessionCheckedPromise doesn't exist, then promise completes immediately
        await Promise.race([(<any>window).DepositAccount.sessionCheckedPromise, timeout(500)]);
        const stateString = getCookie('geostate');
        resolve({ geostate: stateString });
    });
    return stateCodePromise;
}

function parseInt(value: string | undefined): number | undefined {
    if (!value) {
        return undefined;
    }
    const parseInt = Number.parseInt || (<any>window).parseInt; //fall back to window for IE
    const isNaN = Number.isNaN || (<any>window).isNaN; //fall back to window for IE

    const dma = parseInt(value, 10);
    if (isNaN(dma)) {
        return undefined;
    }
    return dma;
}

function timeout(ms: number) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    })
}

export default {
    getDmaCode,
    getStateCode
}